import React from 'react';

import { i18n } from '@lt/localization';
import { formatDistance } from '@lt/components/utils/userflow';
import DistanceIcon from '@lt/components/icons-react/hotel-facts/HotelBeachDistance';
import HotelFeature from '../HotelFeature';

import styles from './beachDistanceFeature.module.css';

const LABEL = i18n.t('hotelcard.facts.beach.label');

type BeachDistanceFeatureProps = {
  value: number | null;
  isMobile: boolean;
};

const BeachDistanceFeature: React.FC<BeachDistanceFeatureProps> = ({
  value,
  isMobile,
}) =>
  value ? (
    <HotelFeature
      Label={LABEL}
      Icon={
        <div className={styles.iconContainer}>
          <DistanceIcon className={styles.distanceIcon} />
          <span className={styles.label}>{formatDistance(value)}</span>
        </div>
      }
      isMobile={isMobile}
    />
  ) : null;

export default BeachDistanceFeature;
